
































































































































































































import { Vue, Prop, Component } from 'vue-property-decorator';
import {
  Unit, Settings, User, UserApi, UnitsApi,
} from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import Searchfield from '@/components/Form/Searchfield/index.vue';
import UnitsList from '@/components/Table/UnitsList/index.vue';
import PageTitle from '@/components/PageTitle/index.vue';
import SystemModule from '@/store/modules/system';
import ToastModule from '@/store/modules/toast';
import MarketUtil from '@/util/MarketUtil';
import Format from '@/util/Format';
import AppModule from '@/store/modules/app';
import ServiceUtil from '@/util/ServiceUtil';
import UnitsUtil from '@/util/UnitUtil';
import PermissionMixin from '@/mixins/PermissionMixin';
import RestaurantPartnersDelete from '@/components/Modal/RestaurantPartnersDelete/index.vue';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    PrimaryButton,
    Searchfield,
    UnitsList,
    PageTitle,
    RestaurantPartnersDelete,
  },
})
export default class Units extends mixins(PermissionMixin) {
  private search: string = '';

  public error: string = '';

  public marketItems: Settings[] = [];

  private scoutItems: User [] = [];

  private marketsLoaded: boolean = false;

  private scoutsLoaded: boolean = false;

  public loading: boolean = false;

  public marketCheck: string = '';

  public searchMarket: any = '';

  public scoutCheck: string = '';

  public searchScout: any = '';

  public searchStatus: any = '';

  public statusCheck: string = '';

  private dialog: boolean = false;

  private unitListProfiles: any[] = [];

  private unitsArray: any[] = [];

  private showDeleteIcon: boolean = false;

  private unitDeleteCheck: boolean = false;

  private profileValue: any = {
    deleteProfile: '',
    saving: false,
  }

  private statusItems = [
    {
      text: 'Active',
      value: 'Active',
    },
    {
      text: 'Inactive',
      value: 'Inactive',
    },
  ];

  public onMarket(data: any) {
    this.updateQuery(JSON.stringify(data), 'market');
  }

  public onScout(data: any) {
    this.updateQuery(JSON.stringify(data), 'scout');
  }

  public onStatus(data: any) {
    this.updateQuery(JSON.stringify(data), 'status');
  }

  public onSearch(data: any) {
    this.updateQuery(data, 'search');
  }

  public updateQuery(data: any, key: string) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [key]: data,
      },
    });
  }

  public resetQuery() {
    this.$router.replace({
      query: {},
    });
  }

  public mounted() {
    if (this.$route.query) {
      const {
        status,
        scout,
        market,
        search,
      } = this.$route.query;
      if (status) {
        this.searchStatus = JSON.parse((status as any));
      }
      if (scout) {
        this.searchScout = JSON.parse((scout as any));
      }
      if (market) {
        this.searchMarket = JSON.parse((market as any));
      }
      if (search !== null) {
        (this.search as any) = search;
      }
    }

    this.watchMenuClose('marketSelectRef', () => {
      this.marketCheck = '';
    });
    this.watchMenuClose('scoutSelectRef', () => {
      this.scoutCheck = '';
    });
    this.watchMenuClose('statusSelectRef', () => {
      this.statusCheck = '';
    });

    this.getMarkets();
    this.getScouts();
  }

  private watchMenuClose(refName: string, reset: () => void) {
    this.$watch(
      () => (this.$refs[refName] as any)?.isMenuActive,
      (val: boolean) => {
        if (!val) reset();
      },
    );
  }

  public async getMarkets() {
    try {
      const { markets }: any = SystemModule;
      const items = MarketUtil.getMappedMarkets(markets);
      (this.marketItems) = Format.sortedItems(items);
    } catch (err) {
      if (err.error) {
        console.log(err.error);
      }
    } finally {
      this.marketsLoaded = true;
    }
  }

  public async getScouts() {
    try {
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        const api = new UserApi(AppModule.apiConfig);
        const users = await api.getUsers();
        ((this.scoutItems) as any) = UnitsUtil.scoutListFormatted(users.data);
      }
    } catch (err) {
      if (err.error) {
        console.log(err.error);
      }
    } finally {
      this.scoutsLoaded = true;
    }
  }

  get marketItemsFiltered() {
    const filterSearchUnits = UnitsUtil.searchUnitItems(
      (this.marketItems as any), this.marketCheck,
    );
    return filterSearchUnits;
  }

  get scoutItemsFiltered() {
    const filteredScouts = UnitsUtil.searchUnitItems(
      (this.scoutItems as any), this.scoutCheck,
    );
    return filteredScouts;
  }

  get statusItemsFiltered() {
    const filteredStatus = UnitsUtil.searchUnitItems(
      (this.statusItems as any), this.statusCheck,
    );
    return filteredStatus;
  }

  public clearSearchAll() {
    this.searchMarket = [];
    this.searchStatus = [];
    this.searchScout = [];
    this.marketCheck = '';
    this.scoutCheck = '';
    this.statusCheck = '';
    this.resetQuery();
  }

  public onAddUnit() {
    this.$router.push('/units/create-unit/');
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  public openDialog() {
    this.dialog = true;
  }

  public onCloseDialog() {
    this.unitListProfiles = [];
    this.unitsArray = [];
    this.profileValue.deleteProfile = '';
    this.dialog = false;
  }

  public async onDelete() {
    try {
      this.profileValue.saving = true;
      const api = new UnitsApi(AppModule.apiConfig);
      const user = await api.deleteUnit(this.unitListProfiles as any);
      if (user.status === 200) {
        this.profileValue.deleteProfile = '';
        this.unitDeleteCheck = true;
        ToastModule.setToast({
          message: 'Unit has been deleted',
          timeout: 5000,
        });
        this.unitListProfiles = [];
        this.unitsArray = [];
        this.dialog = false;
      }
    } catch (err) {
      const { error } = err.response.data;
      ToastModule.setToast({
        message: error.message,
        timeout: 5000,
      });
    }
    this.profileValue.saving = false;
  }
}
